export const EMPTY_RECORDING = { 'title': '', 'artist': '', 'isrc': '', 'duration': '' }
export const EMPTY_INPUT = ''
export const EMPTY_FIELD = ''
